<span *ngIf="transactionType">{{ transactionType }}</span>
